// extracted by mini-css-extract-plugin
export default {"button":"ButtonArrow_button__y0Gqg","buttonText":"ButtonArrow_buttonText__vuch1","buttonIcon":"ButtonArrow_buttonIcon__vk31y","noText":"ButtonArrow_noText__l61RP"};